import AnswerContainer from './answer-container';
import { IMessage, MessageType } from '../../common/types';
import { cn } from '../../lib/utils';

interface LiveChatMessageProps {
  message: IMessage;
}

function LiveChatMessage(props: LiveChatMessageProps) {
  const isNotice = props.message.type === MessageType.LiveChatNotice;

  return (
    <AnswerContainer
      className={cn(
        isNotice
          ? 'border-dashed bg-slate-50 text-sm text-slate-600'
          : 'border-[#d8e3ef] bg-white text-[#13233a]'
      )}
    >
      {props.message.senderName && !isNotice && (
        <div className="mb-1 text-xs font-semibold text-slate-500">{props.message.senderName}</div>
      )}
      <div
        className="markdown-renderer whitespace-normal break-words"
        dangerouslySetInnerHTML={{ __html: props.message.message }}
      />
    </AnswerContainer>
  );
}

export default LiveChatMessage;
